import React from 'react';
import './header.css';
import { useDispatch } from "react-redux";
import { sidebarAction } from "../../redux/rootReducer";

const Header = ({ component }) => {
    const dispatch = useDispatch();

    return (
        <div className={ 'header' }>
            <div className="header__top">
                <i className="header__menu" onClick={ () => {
                    dispatch(sidebarAction(true));
                } } />
            </div>
            { component }
        </div>
    );
};

export default Header;